import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=1c18d9cf&"
import script from "./SendIcon.vue?vue&type=script&lang=js&"
export * from "./SendIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports